import {
  ISendElasticEventOptions,
  IAnalyticsService,
  OrbitUserFlowAnalyticsCategory,
  OrbitUserFlowAnalyticsAction,
  OrbitUserFlowAnalyticsLabel,
  OrbitMarketingEventAnalyticsCategory,
  OrbitMarketingEventAnalyticsLabel,
  OrbitMarketingEventAnalyticsAction,
  OrbitAIFeatureAnalyticsCategory,
  OrbitAIFeatureAnalyticsAction
} from './analytics.service.interface';
import {ServiceBase} from '../ServiceBase';
import {IElasticEventData, IStructuredLogger} from '../../../common/interfaces/structured-logging-service-interface';
import {Check} from "@sparkware/app-utils";

export class AnalyticsService extends ServiceBase implements IAnalyticsService {

  sendAnalytics(
    category: string,
    action: string | undefined = undefined,
    label: string | undefined = undefined,
    value: string | undefined = undefined,
    omitStructuredLogger?: boolean
  ) {
    this.services.sdk.sendAnalytics(category, action, label, value, omitStructuredLogger);
  }


  sendTechnicalEvent(action: string, label?: string, value?: any): void {
    this.sendAnalytics('[Technical-event]', action, label, value);
  }

  sendOrbitUserFlowEvent(category: string | OrbitUserFlowAnalyticsCategory, action: OrbitUserFlowAnalyticsAction, label?: string | OrbitUserFlowAnalyticsLabel, value?: any): void {
    try {
      let data:ISendElasticEventOptions ={
        eventType:"Orbit_User_Flow",
        category:category,
        action:action,
        label:label,
        value: value
      }
      this.sendElasticInfoEvent(data, true);
    }
    catch (err){
      console.log("Error on Orbit sendOrbitUserFlowEvent : " + err);
    }
  }

  sendOrbitMarketingEvent(category: string | OrbitMarketingEventAnalyticsCategory, action: OrbitMarketingEventAnalyticsAction, label?: string | OrbitMarketingEventAnalyticsLabel, value?: any): void {
    try {
      let data:ISendElasticEventOptions ={
        eventType:"Orbit_Marketing",
        category:category,
        action:action,
        label:label,
        value:value
      }
      this.sendElasticInfoEvent(data, true);
    }
    catch (err){
      console.log("Error on Orbit sendOrbitMarketingEvent : " + err);
    }
  }

  sendOrbitAIFeatureEvent(category: string | OrbitAIFeatureAnalyticsCategory, action: OrbitAIFeatureAnalyticsAction, label?: string, value?: any): void {
    try {
      let data: ISendElasticEventOptions = {
        eventType: "Orbit_AI_Feature",
        category: category,
        action: action,
        label: label,
        value: value
      }
      this.sendElasticInfoEvent(data, true);
    } catch (err) {
      console.log("Error on Orbit sendOrbitAIFeatureEvent : " + err);
    }
  }

  sendElasticInfoEvent(options: ISendElasticEventOptions, sendToDWH?: boolean) {
    const logger: IStructuredLogger = this.services.sdk.structuredLoggingService
      .getLogger()
      .addCategory(options.category)
      .addAction(options.action)
      .addLabel(options.label)
      .addValue(options.value)
      .addCustomData(options.customData);

    if (!Check.isNullOrUndefined(options.appID)) {
      logger.setAppID(options.appID);
    }

    if (sendToDWH) {
      logger.setEventType(options.eventType,'Log', 'Analytics');
    }
    else {
      logger.setEventType(options.eventType, 'Log');
    }

    logger.info();
  }

  getLogger(eventData?: IElasticEventData): IStructuredLogger {
    return this.services.sdk.structuredLoggingService.getLogger(eventData);
  }

  getGoogleClientID(): string {
    return this.services.sdk.getGoogleClientID();
  }

  async writeWidgetLogs(payload: any): Promise<void> {
    await this.services.sdk.writeWidgetLogs(payload)
  }
}
